import { VehicleRowGroup } from 'src/pages/ConvenienceDispatches/adapter';

/**
 * 「すべて展開 / すべて閉じる」の対象になる行 ID。
 *
 * 展開トグルは全行に出しているので、選択 (collectSelectableRowIds) と違って
 * 固定ルート合成行も含める。
 */
export function collectExpandableRowIds(rowGroups: readonly VehicleRowGroup[]): string[] {
  return rowGroups.flatMap((group) => group.rows.map((r) => r.rowId));
}

/** すべて展開済みか。対象ゼロを true にしない（空の画面でボタンが「すべて閉じる」になってしまう） */
export function allRowsExpanded(
  expandableRowIds: readonly string[],
  expandedRowIds: ReadonlySet<string>,
): boolean {
  return expandableRowIds.length > 0 && expandableRowIds.every((id) => expandedRowIds.has(id));
}

/**
 * トグル後の展開集合。全て展開済みなら閉じ、そうでなければ全て展開する。
 *
 * 対象外（絞り込みで隠れている行）の展開はどちらの向きでも触らない。畳んでしまうと
 * 絞り込みを戻したときに、開いていたはずの行が勝手に閉じて見える。
 */
export function toggleAllExpandedRowIds(
  expandableRowIds: readonly string[],
  expandedRowIds: ReadonlySet<string>,
): ReadonlySet<string> {
  if (allRowsExpanded(expandableRowIds, expandedRowIds)) {
    const target = new Set(expandableRowIds);
    return new Set([...expandedRowIds].filter((id) => !target.has(id)));
  }
  return new Set([...expandedRowIds, ...expandableRowIds]);
}
